import React, { Component } from 'react';
import PropTypes from 'prop-types';


const SENTIMENTS_AND_EMOTIONS = 'Sentiments and Emotions';

export class CommentSentimentsAndEmotionsFilter extends Component {

  static propTypes = {
    commentFilterItems: PropTypes.array.isRequired,
    handleCommentsFilter: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isCommentSentimentsAndEmotionsFilter: true,
      commentFilterItems: []
    };
    this.wrapperRef = React.createRef();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this._setCommentFilterItemsToStateIfItChanged(nextProps);
  }

  _setCommentFilterItemsToStateIfItChanged(nextProps) {
    if (
      nextProps.commentFilterItems && 
      JSON.stringify(nextProps.commentFilterItems) !== JSON.stringify(this.state.commentFilterItems)
    ) {
      this.setState({
        commentFilterItems: nextProps.commentFilterItems
      });
    }
  }

  toggleCommentSentimentsAndEmotionsFilterIsActive= () => {  
    this.setState(prevState => {
      return { isCommentSentimentsAndEmotionsFilter: !prevState.isCommentSentimentsAndEmotionsFilter };
    });
  }
  

  handleClickOutside = event => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({isCommentSentimentAndEmotionFilter: false });
    }
  }

  render() {
    const {
      isCommentSentimentsAndEmotionsFilter
    } = this.state;

    return ( 
      <div>
        <div
          className={`input-container-sentiments-and-emotions ${isCommentSentimentsAndEmotionsFilter ? 'active' : ''}`}
          ref={this.wrapperRef}
        >
          <div
            className="sentimens-and-emotions-dropdown"
            onClick={() => this.toggleCommentSentimentsAndEmotionsFilterIsActive()}
          >
            <div className='dropdown-placeholder'>{SENTIMENTS_AND_EMOTIONS}</div>
            <i className={`la la-${isCommentSentimentsAndEmotionsFilter ? 'minus' :'plus'}`} />
          </div>
        </div>
        {isCommentSentimentsAndEmotionsFilter && (
          <div className='comments-filter-item'>
            {this.props.commentFilterItems.map((commentFilter, index) => (
            <div className="select-item" key={index}>
              <input
              className="styled-checkbox"
              id={`checkbox-${commentFilter.name}`}
              type="checkbox"
              onChange={e => this.props.handleCommentsFilter(e)}
              value={commentFilter.value}
              checked={commentFilter.checked}
              />
              <label htmlFor={`checkbox-${commentFilter.name}`}>{commentFilter.name}</label>
            </div>
            ))}
          </div>
        )}
      </div>
    )
  }
}

export default CommentSentimentsAndEmotionsFilter;


// WEBPACK FOOTER //
// ./src/features/home/components/comment-filter/CommentSentimentsAndEmotionsFilter.js